import { useLocation } from "react-router-dom";

const ErrorPage = () => {
  const location = useLocation();

  const errorMessage =
    location.state?.message || "An unexpected error occurred.";

  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h2>Oops!</h2>
      <p>{errorMessage}</p>
      <p>
        If you need assistance, please contact{" "}
        <a href="mailto:request@oxforddoc.com">request@oxforddoc.com</a>.
      </p>
    </div>
  );
};

export default ErrorPage;
